import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableWithHeadingAndSearch from '../components/Table/TableWithHeadingAndSearch';
import {
    fetchPurchaseOrders,
    getPurchaseOrders,
} from '../app/reducers/PurchaseOrder/purchaseOrderSlice';
import moment from 'moment-timezone';
import {
    fetchComplaints,
    getComplaints,
} from '../app/reducers/Complaints/complaintSlice';
import { authAxiosInstance } from '../utils/axiosConfig';
import PoReportCard from '../components/infrastructure/cards/PoReportCard';
import { getAuth } from '../app/reducers/Auth/authSlice';
import QueryString from 'qs';
import DeliveryExecutiveDashboard from './PurchaseOrder/DeliveryExecutiveDashboard';
import { useNavigate } from 'react-router-dom';
import DocumentPreview from './Products/DocumentPreview';
import VideoPreview from './Products/VideoPreview';
import PrimaryButton from '../components/infrastructure/Buttons/PrimaryButton';

const Dashboard = () => {
    const { user } = useSelector(getAuth)
    const { purchaseOrder, loading: poLoading } =
        useSelector(getPurchaseOrders);
    const { complaint, loading: compLoading } = useSelector(getComplaints);
    console.log('comp.s', complaint);
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const [Po_report, setPo_Report] = useState([]);
    const [complaints_report, setComplaints_Report] = useState({});
    const [Quotation, setQuotation_Report] = useState([]);
    const [previewModalOpen, setPreviewModalOpen] = useState(false);
    const [previewImg, setPreviewImg] = useState([]);
    const [previewVideoModalOpen, setPreviewVideoModalOpen] = useState(false);
    const [previewVideos, setPreviewVideos] = useState([]);
    const [employees, setEmployees] = useState([]);

    useEffect(() => {
        dispatch(
            fetchPurchaseOrders({
                populate: true,
                createdAt: {
                    $gte: moment().startOf('day').valueOf(),
                    $lte: moment().endOf('day').valueOf(),
                },
            })
        );
        dispatch(
            fetchComplaints({
                populate: true,
                createdAt: {
                    $gte: moment().startOf('month').valueOf(),
                    $lte: moment().endOf('month').valueOf(),
                },
            })
        );
    }, []);

    const fetchReportsNumber = async () => {
        // try {
        //     const query = QueryString.stringify({
        //         createdAt:{
        //             $gte:moment().startOf("day").valueOf(),
        //             $lte:moment().endOf("day").valueOf()
        //         }
        //     });
        //     const res = await authAxiosInstance.get(
        //         `purchaseOrder/report?${query}`
        //     );
        // } catch (error) {}
        const res = await authAxiosInstance.get(`purchaseOrder/report`);
        if (res?.data?.data?.length) {
            const dataObj = res.data.data.reduce((acc, item) => {
                if (item?._id) {
                    acc[item._id] = {
                        count: item.count,
                        cyan: item.totalCyan,
                        magenta: item.totalMagenta,
                        yellow: item.totalYellow,
                        black: item.totalBlack,
                        cleaningSolution: item.totalCleaningSolution,
                        totalColor:
                            item.totalCyan +
                            item.totalMagenta +
                            item.totalYellow +
                            item.totalBlack +
                            item.totalCleaningSolution,
                    };
                }
                return acc;
            }, {});
            setPo_Report(dataObj);
        }
    };
    const fetchComplaintsReportsNumber = async () => {
        // try {
        //     const query = QueryString.stringify({
        //         createdAt:{
        //             $gte:moment().startOf("day").valueOf(),
        //             $lte:moment().endOf("day").valueOf()
        //         }
        //     });
        //     const res = await authAxiosInstance.get(
        //         `purchaseOrder/report?${query}`
        //     );
        // } catch (error) {}
        const res = await authAxiosInstance.get(`complaint/report`);
        if (res?.data?.data?.length) {
            const dataObj = res.data.data.reduce((acc, item) => {
                if (item?._id) {
                    acc[item._id] = item.count;
                }
                return acc;
            }, {});
            setComplaints_Report(dataObj);
        }
    };
    const fetchQuotationsReportsNumber = async () => {
        // try {
        //     const query = QueryString.stringify({
        //         createdAt:{
        //             $gte:moment().startOf("day").valueOf(),
        //             $lte:moment().endOf("day").valueOf()
        //         }
        //     });
        //     const res = await authAxiosInstance.get(
        //         `purchaseOrder/report?${query}`
        //     );
        // } catch (error) {}
        let query = {}
        if (!['sup_admin', 'admin'].includes(user.role)) {

            query = { createdBy: user.username }
        }
        const string = QueryString.stringify(query)
        const res = await authAxiosInstance.get(`quotation/report?${string}`);
        // if (res?.data?.data?.length) {
        //     const dataObj = res.data.data.reduce((acc, item) => {
        //         if (item?._id) {
        //             acc[item._id] = item.count;
        //         }
        //         return acc;
        //     }, {});
        //     setQuotation_Report(dataObj);
        // }
        const count = res?.data?.data;
        setQuotation_Report(count);
    };
    console.log("Quotation", Quotation)
    const fetchUsers = async () => {
        try {
            const resp = await authAxiosInstance.get(`/users/employee?${QueryString.stringify({ limit: 500 })}`);
            if (resp?.data?.data?.docs?.length > 0) {
                setEmployees(resp?.data?.data?.docs)
            } else {
                setEmployees([])
            }
        } catch (error) {
            console.log("error", error)
        }
    }

    useEffect(() => {
        fetchUsers();
        fetchReportsNumber();
        fetchComplaintsReportsNumber();
        fetchQuotationsReportsNumber();
    }, []);

    const poCol = [
        {
            Header: 'SRNO',
            Cell: (prop) => {
                const { data, row } = prop;
                return row.index + purchaseOrder?.pagingCounter;
            },
        },
        {
            Header: 'Date',
            Cell: (prop) => {
                const { data, row } = prop;
                return moment(row?.original?.createdAt).format(
                    'DD/MM/YYYY HH:mm'
                );
            },
        },
        {
            Header: 'ORD_Number',
            accessor: 'orderNumber',
        },
        {
            Header: 'Customer',
            accessor: 'customer.name',
        },
        {
            Header: 'Company',
            accessor: 'customer.companyData.name',
        },
        {
            Header: 'Product',
            accessor: 'product.name',
        },
        {
            Header: 'Status',
            accessor: 'status',
        },
        {
            Header: 'Cyan',
            accessor: 'cyan',
        },
        {
            Header: 'Magenta',
            accessor: 'magenta',
        },
        {
            Header: 'Black',
            accessor: 'black',
        },
        {
            Header: 'Yellow',
            accessor: 'yellow',
        },
        {
            Header: 'Cleaning Solution',
            accessor: 'cleaningSolution',
        },
        {
            Header: 'Customer Message',
            accessor: 'customerMessage',
        },
    ];

    const compCol = [
        {
            Header: 'SRNO',
            Cell: ({ row }) => {
                return (
                    <div className="w-[150px] space-y-2">
                        <div>
                            <p className="text-sm font-semibold text-slate-800">
                                {row.index + complaint?.pagingCounter}
                            </p>
                        </div>

                        <div className="bg-slate-50 rounded-lg p-2 text-xs">
                            <p className="text-slate-500 uppercase tracking-wide">
                                Technician
                            </p>
                            <p className="mt-1 font-semibold text-slate-800 text-wrap">
                                {row?.original?.assignedTo || '--'}
                            </p>
                        </div>
                    </div>
                );
            },
        },
        {
            Header: 'Date',
            Cell: ({ row }) => {
                const dates = [];
                if (row?.original?.createdAt) {
                    dates.push(`Op :- ${moment(row?.original?.createdAt).format('DD/MM/YYYY HH:mm')}`);
                }
                if (row?.original?.inProgressDate) {
                    dates.push(`Ip :- ${moment(row?.original?.inProgressDate).format('DD/MM/YYYY HH:mm')}`);
                }
                if (row?.original?.timeInDate) {
                    dates.push(`TimeIn :- ${moment(row?.original?.timeInDate).format('DD/MM/YYYY HH:mm')}`);
                }
                if (row?.original?.pendingDate) {
                    dates.push(`Pending :- ${moment(row?.original?.pendingDate).format('DD/MM/YYYY HH:mm')}`);
                }
                if (row?.original?.observationDate) {
                    dates.push(`Obs :- ${moment(row?.original?.observationDate).format('DD/MM/YYYY HH:mm')}`);
                }
                if (row?.original?.closedDate) {
                    dates.push(`Cld :- ${moment(row?.original?.closedDate).format('DD/MM/YYYY HH:mm')}`);
                }
                if (row?.original?.cancelDate) {
                    dates.push(`Cncl :- ${moment(row?.original?.cancelDate).format('DD/MM/YYYY HH:mm')}`);
                }
                return (
                    <div className="flex flex-col gap-x-3 gap-y-1 w-[150px]">
                        {dates.map((d, i) => (
                            <p key={i} className="text-xs whitespace-nowrap">{d}</p>
                        ))}
                    </div>
                );
            },
        },
        {
            Header: 'Company',
            Cell: ({ row }) => {
                const companyName = row.original?.customer?.companyData?.name;
                const customerName = row.original?.customer?.name;
                const location =
                    row.original?.customer?.dispatchLocationData?.name;
                const complaintNumber = row.original?.complaintNumber;

                const executiveIds =
                    row.original?.customer?.companyData?.executive || [];

                const executiveNames = employees
                    ?.filter((emp) => executiveIds?.includes(emp._id))
                    ?.map(
                        (emp) =>
                            `${emp.firstName || ''} ${emp.lastName || ''}`.trim()
                    )
                    ?.filter(Boolean)
                    ?.join(', ');

                return (
                    <div className="w-[250px]">
                        <div className="font-semibold text-slate-800">
                            {companyName || '--'}
                        </div>

                        <div className="text-xs text-slate-500 mb-2">
                            {customerName || '--'}
                        </div>

                        <div className="space-y-2 text-xs">
                            <div className="flex items-center gap-2">
                                <span className="font-medium text-slate-500 w-[90px]">
                                    Complaint No.
                                </span>
                                <span className="px-2 py-0.5 rounded bg-blue-50 text-blue-700">
                                    {complaintNumber || '--'}
                                </span>
                            </div>

                            <div className="flex items-center gap-2">
                                <span className="font-medium text-slate-500 w-[90px]">
                                    Executive
                                </span>
                                <span className="px-2 py-0.5 rounded bg-green-50 text-green-700 text-wrap">
                                    {executiveNames || '--'}
                                </span>
                            </div>

                            <div className="flex items-center gap-2">
                                <span className="font-medium text-slate-500 w-[90px]">
                                    Location
                                </span>
                                <span className="px-2 py-0.5 rounded bg-purple-50 text-purple-700 text-wrap">
                                    {location || '--'}
                                </span>
                            </div>
                        </div>
                    </div>
                );
            },
        },
        // {
        //     Header: 'Complaint No.',
        //     accessor: 'complaintNumber',
        // },
        // {
        //     Header: 'Photos',
        //     Cell: ({ row }) => {
        //         return (
        //             <div className="flex flex-col w-[100px] gap-2">
        //                 {row.original?.photos?.map &&
        //                     row.original.photos.map((ele) => (
        //                         <a
        //                             href={`${process.env.REACT_APP_S3_URL}${ele}`}
        //                             target="_blank"
        //                         >
        //                             <img
        //                                 src={`${process.env.REACT_APP_S3_URL}${ele}`}
        //                             />
        //                         </a>
        //                     ))}
        //             </div>
        //         );
        //     },
        // },
        // {
        //     Header: 'Videos',
        //     Cell: ({ row }) => {
        //         return (
        //             <div className="flex flex-col w-[100px] gap-2">
        //                 {row.original?.videos?.map &&
        //                     row.original.videos.map((ele, i) => (
        //                         <a
        //                             className="text-indigo-500 underline"
        //                             href={`${process.env.REACT_APP_S3_URL}${ele}`}
        //                             target="_blank"
        //                         >
        //                             <p>Video {i + 1}</p>
        //                         </a>
        //                     ))}
        //             </div>
        //         );
        //     },
        // },
        // {
        //     Header: 'Company',
        //     Cell: ({ row }) => {
        //         const companyName = row.original?.customer?.companyData?.name;
        //         const customerName = row.original?.customer?.name;
        //         return (
        //             <div className="w-[150px] space-y-1 ">
        //                 <p className="text-sm font-semibold text-wrap text-gray-800 ">
        //                     {companyName || '--'}
        //                 </p>
        //                 <p className="text-xs text-gray-500 text-wrap ">
        //                     {customerName || '--'}
        //                 </p>
        //             </div>
        //         );
        //     }
        // },
        // {
        //     Header: 'Executive',
        //     Cell: ({ row }) => {
        //         const location = row.original?.customer?.dispatchLocationData?.name;
        //         return (
        //             <div className="w-[150px] space-y-1">
        //                 <p className="text-xs text-gray-500 text-wrap">
        //                     <span className="font-medium text-gray-600">Location:</span> {location || '--'}
        //                 </p>
        //             </div>
        //         );
        //     }
        // },
        {
            Header: 'Machine',
            accessor: 'product.name',
            Cell: (({ row }) => {
                return (
                    <div className='w-[150px]'>
                        <p className='text-wrap'>{row?.original?.product?.name}</p>
                    </div>
                )
            })
        },
        {
            Header: 'Description',
            Cell: ({ row }) => {
                return (
                    <div className="w-[300px]">
                        <p className="text-wrap ">
                            {row?.original?.description}
                        </p>
                    </div>
                );
            },
        },
        // {
        //     Header: 'Technician',
        //     Cell: ({ row }) => {
        //         return (
        //             <div className='w-[100px]'>
        //                 <p className='text-wrap'>{row?.original?.assignedTo || '--'}</p>
        //             </div>
        //         );
        //     },
        // },
        {
            Header: 'Observation',
            Cell: ({ row }) => {
                return (
                    <div className="w-[200px]">
                        <p className='text-wrap'>{row?.original?.observationNotes || '--'}</p>
                    </div>
                );
            },
        },
        {
            Header: 'Ob Date',
            Cell: ({ row }) => {
                return (
                    <div>
                        {row.original.observationDate
                            ? moment
                                .tz(
                                    row?.original?.observationDate,
                                    'Asia/Kolkata'
                                )
                                .format('DD-MM-YYYY')
                            : '--'}
                    </div>
                );
            },
        },
        {
            Header: 'Resolution',
            Cell: ({ row }) => {
                return (
                    <div className="w-[200px]">
                        <p className='text-wrap'>{row?.original?.resolution || '--'}</p>
                    </div>
                );
            },
        },
        {
            Header: 'Cancellation',
            Cell: ({ row }) => {
                return (
                    <div className="max-w-[300px] w-[300px] text-wrap">
                        {row?.original?.cancellationNotes || '--'}
                    </div>
                );
            },
        },
        {
            Header: 'Cancel Date',
            Cell: ({ row }) => {
                return (
                    <div>
                        {row.original.cancelDate
                            ? moment
                                .tz(row?.original?.cancelDate, 'Asia/Kolkata')
                                .format('DD-MM-YYYY')
                            : '--'}
                    </div>
                );
            },
        },
        {
            Header: 'Status',
            accessor: 'status',
        },
        {
            Header: 'Photo / Video',
            Cell: ({ row }) => {
                const photos = row.original?.photos || [];
                const videos = row.original?.videos || [];

                return (
                    <div className="w-[150px] flex flex-col gap-3">
                        {/* Photos */}
                        <div className="rounded border border-slate-200 p-2">
                            <p className="text-xs font-medium text-slate-500 mb-2">
                                Photos
                            </p>

                            {photos.length > 0 ? (
                                <>
                                    <img
                                        src={`${process.env.REACT_APP_S3_URL}${photos[0]}`}
                                        alt="Preview"
                                        className="h-20 w-full rounded object-cover border"
                                    />

                                    <PrimaryButton
                                        className="w-full mt-2 p-1 text-xs"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setPreviewImg(photos);
                                            setPreviewModalOpen(true);
                                        }}
                                    >
                                        View More ({photos.length})
                                    </PrimaryButton>
                                </>
                            ) : (
                                <p className="text-xs text-slate-400">
                                    No Photos
                                </p>
                            )}
                        </div>

                        {/* Videos */}
                        <div className="rounded border border-slate-200 p-2">
                            <p className="text-xs font-medium text-slate-500 mb-2">
                                Videos
                            </p>

                            {videos.length > 0 ? (
                                <>
                                    <div className="text-sm text-slate-700 truncate">
                                        🎥 Video 1
                                    </div>

                                    <PrimaryButton
                                        className="w-full mt-2 p-1 text-xs"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setPreviewVideos(videos);
                                            setPreviewVideoModalOpen(true);
                                        }}
                                    >
                                        View More ({videos.length})
                                    </PrimaryButton>
                                </>
                            ) : (
                                <p className="text-xs text-slate-400">
                                    No Videos
                                </p>
                            )}
                        </div>
                    </div>
                );
            },
        },
    ];

    const poData = useMemo(() => {
        if (purchaseOrder && purchaseOrder?.docs) return purchaseOrder?.docs;
        else return [];
    }, [purchaseOrder]);

    const compData = useMemo(() => {
        if (complaint && complaint?.docs) return complaint?.docs;
        else return [];
    }, [complaint]);

    return (
        <>
            <DocumentPreview
                previewModalOpen={previewModalOpen}
                setPreviewModalOpen={setPreviewModalOpen}
                previewImg={previewImg}
            />
            <VideoPreview
                previewModalOpen={previewVideoModalOpen}
                setPreviewModalOpen={setPreviewVideoModalOpen}
                previewVideos={previewVideos}
            />
            {user?.role !== 'delivery_executive' ? (
                <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
                    {/* Page header */}
                    <div className="mb-8">
                        <h1 className="text-2xl md:text-3xl text-slate-800 font-bold">
                            Dashboard
                        </h1>
                        <p className="text-sm text-slate-500 mt-1">{moment().format('dddd, MMMM D, YYYY')}</p>
                    </div>

                    {/* Complaints report */}
                    <div className="mb-6">
                        <h2 className="text-xs font-semibold text-slate-400 uppercase tracking-widest mb-4 pl-1 border-l-2 border-indigo-500">
                            Complaints
                        </h2>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                            {user?.role !== 'engineer' && (
                                <div className="bg-white shadow-lg rounded-sm border border-slate-200 p-5 flex flex-col items-center justify-center gap-3 transition-all duration-200 hover:-translate-y-1 hover:shadow-xl">
                                    <a
                                        href="/complaint/view-complaint/open"
                                        onClick={(e) => e.stopPropagation()}
                                        className="w-full h-full flex flex-col items-center justify-center gap-3"
                                    >
                                        <h2 className="text-xs font-semibold text-slate-500 uppercase tracking-widest">
                                            Open
                                        </h2>
                                        <p className="text-4xl font-bold text-slate-800">
                                            {complaints_report['open'] ?? '—'}
                                        </p>
                                    </a>
                                </div>
                            )}
                            <div className="bg-white shadow-lg rounded-sm border border-slate-200 p-5 flex flex-col items-center justify-center gap-3 transition-all duration-200 hover:-translate-y-1 hover:shadow-xl">
                                <a
                                    href="/complaint/view-complaint/InProgress"
                                    onClick={(e) => e.stopPropagation()}
                                    className="w-full h-full flex flex-col items-center justify-center gap-3"
                                >
                                    <h2 className="text-xs font-semibold text-slate-500 uppercase tracking-widest">
                                        Assigned
                                    </h2>
                                    <p className="text-4xl font-bold text-slate-800">
                                        {complaints_report['InProgress'] ?? '—'}
                                    </p>
                                </a>
                            </div>

                            <div className="bg-white shadow-lg rounded-sm border border-slate-200 p-5 flex flex-col items-center justify-center gap-3 transition-all duration-200 hover:-translate-y-1 hover:shadow-xl">
                                <a
                                    href="/complaint/view-complaint/timeIn"
                                    onClick={(e) => e.stopPropagation()}
                                    className="w-full h-full flex flex-col items-center justify-center gap-3"
                                >
                                    <h2 className="text-xs font-semibold text-slate-500 uppercase tracking-widest">
                                        Time In
                                    </h2>
                                    <p className="text-4xl font-bold text-slate-800">
                                        {complaints_report['timeIn'] ?? '—'}
                                    </p>
                                </a>
                            </div>

                            <div className="bg-white shadow-lg rounded-sm border border-slate-200 p-5 flex flex-col items-center justify-center gap-3 transition-all duration-200 hover:-translate-y-1 hover:shadow-xl">
                                <a
                                    href="/complaint/view-complaint/pending"
                                    onClick={(e) => e.stopPropagation()}
                                    className="w-full h-full flex flex-col items-center justify-center gap-3"
                                >
                                    <h2 className="text-xs font-semibold text-slate-500 uppercase tracking-widest">
                                        Pending
                                    </h2>
                                    <p className="text-4xl font-bold text-slate-800">
                                        {complaints_report['pending'] ?? '—'}
                                    </p>
                                </a>
                            </div>
                            <div className="bg-white shadow-lg rounded-sm border border-slate-200 p-5 flex flex-col items-center justify-center gap-3 transition-all duration-200 hover:-translate-y-1 hover:shadow-xl">
                                <a
                                    href="/complaint/view-complaint/observation"
                                    onClick={(e) => e.stopPropagation()}
                                    className="w-full h-full flex flex-col items-center justify-center gap-3"
                                >
                                    <h2 className="text-xs font-semibold text-slate-500 uppercase tracking-widest">
                                        Observation
                                    </h2>
                                    <p className="text-4xl font-bold text-slate-800">
                                        {complaints_report['observation'] ?? '—'}
                                    </p>
                                </a>
                            </div>

                            <div className="bg-white shadow-lg rounded-sm border border-slate-200 p-5 flex flex-col items-center justify-center gap-3 transition-all duration-200 hover:-translate-y-1 hover:shadow-xl">
                                <a
                                    href="/complaint/view-complaint/closed"
                                    onClick={(e) => e.stopPropagation()}
                                    className="w-full h-full flex flex-col items-center justify-center gap-3"
                                >
                                    <h2 className="text-xs font-semibold text-slate-500 uppercase tracking-widest">
                                        Closed
                                    </h2>
                                    <p className="text-4xl font-bold text-slate-800">
                                        {complaints_report['closed'] ?? '—'}
                                    </p>
                                </a>
                            </div>

                            <div className="bg-white shadow-lg rounded-sm border border-slate-200 p-5 flex flex-col items-center justify-center gap-3 transition-all duration-200 hover:-translate-y-1 hover:shadow-xl">
                                <a
                                    href="/complaint/view-complaint/canceled"
                                    onClick={(e) => e.stopPropagation()}
                                    className="w-full h-full flex flex-col items-center justify-center gap-3"
                                >
                                    <h2 className="text-xs font-semibold text-slate-500 uppercase tracking-widest">
                                        Canceled
                                    </h2>
                                    <p className="text-4xl font-bold text-slate-800">
                                        {complaints_report['canceled'] ?? '—'}
                                    </p>
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* P.O report */}
                    {user?.role !== 'engineer' && <div className="mb-6">
                        <h2 className="text-xs font-semibold text-slate-400 uppercase tracking-widest mb-4 pl-1 border-l-2 border-indigo-500">
                            Purchase Orders
                        </h2>
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                            <PoReportCard
                                name={'P.O Open'}
                                count={Po_report?.open?.count}
                                cyan={Po_report?.open?.cyan}
                                magenta={Po_report?.open?.magenta}
                                yellow={Po_report?.open?.yellow}
                                black={Po_report?.open?.black}
                                cleaningSolution={Po_report?.open?.cleaningSolution}
                                total={Po_report?.open?.totalColor}
                            />
                            <PoReportCard
                                name={'P.O In Progress'}
                                count={Po_report?.inProgress?.count}
                                cyan={Po_report?.inProgress?.cyan}
                                magenta={Po_report?.inProgress?.magenta}
                                yellow={Po_report?.inProgress?.yellow}
                                black={Po_report?.inProgress?.black}
                                cleaningSolution={
                                    Po_report?.inProgress?.cleaningSolution
                                }
                                total={Po_report?.inProgress?.totalColor}
                            />
                            <PoReportCard
                                name={'P.O Dispatched'}
                                count={Po_report?.dispatch?.count}
                                cyan={Po_report?.dispatch?.cyan}
                                magenta={Po_report?.dispatch?.magenta}
                                yellow={Po_report?.dispatch?.yellow}
                                black={Po_report?.dispatch?.black}
                                cleaningSolution={Po_report?.dispatch?.cleaningSolution}
                                total={Po_report?.dispatch?.totalColor}
                            />
                            <PoReportCard
                                name={'P.O Delivered'}
                                count={Po_report?.delivered?.count}
                                cyan={Po_report?.delivered?.cyan}
                                magenta={Po_report?.delivered?.magenta}
                                yellow={Po_report?.delivered?.yellow}
                                black={Po_report?.delivered?.black}
                                cleaningSolution={
                                    Po_report?.delivered?.cleaningSolution
                                }
                                total={Po_report?.delivered?.totalColor}
                            />
                            <PoReportCard
                                name={'P.O Canceled'}
                                count={Po_report?.canceled?.count}
                                cyan={Po_report?.canceled?.cyan}
                                magenta={Po_report?.canceled?.magenta}
                                yellow={Po_report?.canceled?.yellow}
                                black={Po_report?.canceled?.black}
                                cleaningSolution={Po_report?.canceled?.cleaningSolution}
                                total={Po_report?.canceled?.totalColor}
                            />
                            <div className="bg-white shadow-lg rounded-sm border border-slate-200 p-5 flex flex-col items-center justify-center gap-3">
                                <h2 className="text-xs font-semibold text-slate-500 uppercase tracking-widest">
                                    Total Quotations
                                </h2>
                                <p className="text-4xl font-bold text-slate-800">
                                    {Quotation[0]?.count ?? '—'}
                                </p>
                            </div>
                        </div>
                    </div>}



                    {/* Today's tables */}
                    {user?.role !== 'engineer' && <div className="mb-6 w-full overflow-x-auto">
                        <TableWithHeadingAndSearch
                            columns={poCol}
                            data={poData}
                            heading={"Today's P.O"}
                        />
                    </div>}
                    <div className="mb-6 w-full overflow-x-auto">
                        <TableWithHeadingAndSearch
                            columns={compCol}
                            data={compData}
                            heading={"Today's Complaints"}
                        />
                    </div>

                    {/* Content */}
                    <div className="bg-white shadow-lg rounded-sm mb-8">
                        <div className="flex flex-col md:flex-row md:-mr-px"></div>
                    </div>
                </div>
            ) : (
                <DeliveryExecutiveDashboard />
            )}
        </>
    );
};

export default Dashboard;
